import { render } from "./DailySuggestion.vue?vue&type=template&id=af0225d8&scoped=true"
import script from "./DailySuggestion.vue?vue&type=script&lang=js"
export * from "./DailySuggestion.vue?vue&type=script&lang=js"

import "./DailySuggestion.vue?vue&type=style&index=0&id=af0225d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0225d8"]])

export default __exports__